import { render } from "./SubscriptionBadge.vue?vue&type=template&id=c019bff2&scoped=true"
import script from "./SubscriptionBadge.vue?vue&type=script&lang=js"
export * from "./SubscriptionBadge.vue?vue&type=script&lang=js"

import "./SubscriptionBadge.vue?vue&type=style&index=0&id=c019bff2&scoped=true&lang=css"

import exportComponent from "/Users/mac/MyDev/3-READY/v2t/vid2text/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c019bff2"]])

export default __exports__